import { User } from '../../entities-next/user'

export const AUTH_STORE_ID = 'auth'

export type AuthState = {
  readonly currentUserId: number | null
  readonly currentUser: User | null
}
